<template>
<div class="container-fluid">
	<page-loading v-if="!data_loaded" />

	<div v-else class="row">
	    <div class="col-12">
			<h1>Trashed Campaigns</h1>
		</div>
		<div class="col-12">
			<div class="card table-responsive">
    			<table class="campaigns-table table mb-0">
    				<thead>
    					<th></th>
    					<th>Client</th>
    					<th>Title</th>
    					<th>Assigned To</th>
    					<th>Deleted</th>
    					<th></th>
    				</thead>

    				<tr v-for="campaign in campaigns">
    					<td>
    						<input type="checkbox" :value="campaign.id" v-model="ids">
    					</td>
    					<td>
    						<span v-html="campaign.client ? campaign.client.name : '<em>unknown client</em>'" />
    					</td>
    					<td>
							<span v-html="campaign.title" />
    					</td>
    					<td>
    						<span v-html="campaign.assigned_user ? campaign.assigned_user.display_name : '<em>unknown user</em>'" class="text-gray-700" />
    					</td>
    					<td>
    						<span v-html="moment(campaign.deleted_at).format('MMM D, YYYY')" class="text-gray-500" />
    					</td>
    					<td>
    						<button class="btn btn-light btn-sm" v-tooltip.bottom="'Put Back'" @click="restoreItems(campaign.id)"><i class="fal fa-trash-undo text-gray-500"></i></button>
    						<button class="btn btn-light btn-sm" v-tooltip.bottom="'Permadelete'" @click="deleteItems(campaign.id)"><i class="fal fa-times-circle text-gray-500"></i></button>
    					</td>
    				</tr>

    				<tr>
    					<td>
    						<input type="checkbox" @click="toggleAll()">
    					</td>
    					<td colspan="5">
    						<button class="btn btn-primary" :disabled="ids.length < 1" @click="restoreItems()"><i class="fal fa-trash-undo mr-1"></i>Restore Items</button>
    						<button class="btn btn-primary" :disabled="ids.length < 1" @click="deleteItems()"><i class="fal fa-times-circle mr-1"></i>Permanently Delete</button>
    					</td>
    				</tr>
    			</table>
    		</div>
        </div>
    </div>
</div>	

</template>

<script>
	import BreadcrumbsManager from '../../../helpers/BreadcrumbManager';

	export default {
		mixins: [BreadcrumbsManager],

		data() {
			return {
				data_loaded: false,
				campaigns: null,

				ids: [],
			}
		},

		created() {
			this.fetchTrashedCampaigns();
		},

		activated() {
			this.setBreadcrumbs([
	            { text: 'Home', to: { name: 'home' } },
	            { text: 'Trashed Items', to: { name: 'admin.trashed.campaigns'} },
	            { text: 'Campaigns', to: { name: ''} },
        	]);
		},


		methods: {
			deleteItems(id) {
				let ids = id ? [id] : this.ids;
				Swal.fire({
					title: 'Are you sure?',
					text: 'You will *really* not be able to recover the item(s)',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonText: 'Delete',
					cancelButtonText: 'Keep',
					animation: false,
				}).then((result) => {
					if (result.value) {
						this.data_loaded = false;
						axios.post('/api/campaigns/trashed/delete', { ids: ids }).then(({data}) => {
							Swal.fire({
			                    toast: true,
			                    position: 'top-end',
			                    showConfirmButton: false,
			                    timer: 3000,
			                    icon: 'success',
			                    title: 'Items deleted',
			                });
			                this.fetchTrashedCampaigns();					
						});
					}
				});
			},

			fetchTrashedCampaigns() {
				axios.get('/api/campaigns/trashed').then(({data}) => {
					this.campaigns = data;
					this.data_loaded = true;
				})
			},

			restoreItems(id) {
				let ids = id ? [id] : this.ids;
				this.data_loaded = false;
				axios.post('/api/campaigns/trashed/restore', { ids: ids }).then(({data}) => {
					Swal.fire({
	                    toast: true,
	                    position: 'top-end',
	                    showConfirmButton: false,
	                    timer: 3000,
	                    icon: 'success',
	                    title: 'Items restored',
	                });
	                this.fetchTrashedCampaigns();					
				});
			},

			toggleAll() {
				if (this.ids.length > 0) {
					this.ids = [];
				} else {
					this.ids = this.campaigns.map(campaign => campaign.id);
				}
			}
		},
	}
</script>